import { Card, SimpleGrid, Flex, Text, Badge } from "@mantine/core";

// Matches the Overview StatCard look: dimmed label on top, colored value as a
// light badge below.
const STAT_ITEMS = [
  { key: "sent", label: "Sent", color: "blue" },
  { key: "delivered", label: "Delivered", color: "cyan" },
  { key: "opened", label: "Opened", color: "teal" },
  { key: "bounced", label: "Bounced", color: "red" },
  { key: "registered", label: "Registered", color: "green" },
];

const InviteStats = ({ stats, items = STAT_ITEMS }) => {
  return (
    <Card shadow="sm" p="lg" radius="md" withBorder>
      <SimpleGrid cols={{ base: 2, sm: 3, md: 5 }} spacing="xs">
        {items.map((item) => (
          <Flex
            key={item.key}
            align="center"
            justify="space-between"
            direction="column"
            gap="sm"
            wrap="nowrap"
          >
            <Text size="sm" c="dimmed" lineClamp={1} title={item.label}>
              {item.label}
            </Text>
            <Badge size="xl" color={item.color} radius="xl" variant="light">
              {Number(stats?.[item.key] ?? 0)}
            </Badge>
          </Flex>
        ))}
      </SimpleGrid>
    </Card>
  );
};

export default InviteStats;
